module.exports = __webpack_public_path__ + "img/logo-att.bd4e1eaf.png";